import { Component } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { PrincipalService, AuthService, Principal } from '@elderbyte/ngx-auth';
import { environment } from 'src/environments/environment';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  standalone: true,
  imports: [
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    RouterLink,
    AsyncPipe,
    TranslateModule
  ],
  styleUrls: ['./nav.component.css']
})
export class NavComponent {

  translateService: TranslateService;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  constructor(
    private breakpointObserver: BreakpointObserver,
    private principalService: PrincipalService,
    private authService: AuthService,
    private translate: TranslateService) {
    this.translateService = translate;
  }

  public get accountUrl(): string {
    return environment.issuerUrl + '/account';
  }

  public get principal(): Observable<Principal> {
    return this.principalService.principalObservable;
  }

  public login(): void {
    this.authService.goToLogin(location.pathname);
  }

  public logout(): void {
    this.authService.logout();
  }
}
